import { AppConfigModel } from "../abstract/app-config.model";

export class PaymentMethod extends AppConfigModel {

    static override CLASS_NAME: string = 'PaymentMethod';
}
